/**
 * Seat quiz: steps are shown only when mapping rules need an answer.
 * Pant match: exact range → closest higher pantMin (size up) → largest pantMax.
 * Tie-break within a tier: narrowest pant range, then block order.
 */
(function () {
  function parseRules(root) {
    var el = root.querySelector('script[type="application/json"][data-quiz-rules]');
    if (!el || !el.textContent) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function sortByNarrowestThenBlock(a, b) {
    if (a.rangeWidth !== b.rangeWidth) return a.rangeWidth - b.rangeWidth;
    return a.blockIndex - b.blockIndex;
  }

  function findMatch(rules, category, seat, certification, pantSize, fit) {
    var pool = rules.filter(function (r) {
      if (r.category && r.category !== 'any' && r.category !== category) return false;
      if (r.seat && r.seat !== 'any' && r.seat !== seat) return false;
      if (r.certification && r.certification !== 'any' && r.certification !== certification) return false;
      if (r.fit !== 'any' && r.fit !== fit) return false;
      return true;
    });
    if (!pool.length) return null;

    var exact = pool.filter(function (r) {
      return pantSize >= r.pantMin && pantSize <= r.pantMax;
    });
    if (exact.length) {
      exact.sort(sortByNarrowestThenBlock);
      return exact[0];
    }

    var higher = pool.filter(function (r) {
      return r.pantMin > pantSize;
    });
    if (higher.length) {
      higher.sort(function (a, b) {
        if (a.pantMin !== b.pantMin) return a.pantMin - b.pantMin;
        return sortByNarrowestThenBlock(a, b);
      });
      return higher[0];
    }

    var largest = pool.slice().sort(function (a, b) {
      if (b.pantMax !== a.pantMax) return b.pantMax - a.pantMax;
      return sortByNarrowestThenBlock(a, b);
    });
    return largest[0];
  }

  function getApplicablePantSizes(rules, category, seat, certification, pantMin, pantMax, pantStep) {
    var seatVal = seat || 'any';
    var certVal = certification || 'any';
    var step = pantStep || 2;
    var sizes = [];

    rules.forEach(function (r) {
      if (r.category && r.category !== 'any' && r.category !== category) return;
      if (r.seat && r.seat !== 'any' && r.seat !== seatVal) return;
      if (r.certification && r.certification !== 'any' && r.certification !== certVal) return;

      var min = Math.max(Math.ceil(r.pantMin), pantMin);
      var max = Math.min(Math.floor(r.pantMax), pantMax);
      if (min % 2 !== 0) min += 1;
      if (max % 2 !== 0) max -= 1;
      for (var s = min; s <= max; s += step) {
        if (s >= r.pantMin && s <= r.pantMax) {
          sizes.push(s);
        }
      }
    });

    return sizes
      .filter(function (v, i, arr) {
        return arr.indexOf(v) === i;
      })
      .sort(function (a, b) {
        return a - b;
      });
  }

  function hideAllCards(root) {
    root.querySelectorAll('.koz-seat-quiz__result-card').forEach(function (card) {
      card.setAttribute('hidden', '');
      card.setAttribute('aria-hidden', 'true');
    });
  }

  function showCard(root, productId) {
    hideAllCards(root);
    var card = root.querySelector('.koz-seat-quiz__result-card[data-product-id="' + productId + '"]');
    if (card) {
      card.removeAttribute('hidden');
      card.setAttribute('aria-hidden', 'false');
      var title = card.querySelector('.koz-quiz-result__title a, .koz-quiz-result__title');
      if (title && title.focus) title.focus();
    }
  }

  function findQuizVariant(rows, selections) {
    return rows.find(function (row) {
      return row.options.every(function (opt, i) {
        return opt === selections[i];
      });
    });
  }

  function initPantDropdown(root) {
    var wrap = root.querySelector('[data-quiz-pant-dd]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-quiz-pant-input]');
    var btn = wrap.querySelector('[data-quiz-pant-focus]');
    var list = wrap.querySelector('[data-quiz-pant-dd-list]');
    var labelSpan = wrap.querySelector('[data-quiz-pant-dd-label]');
    if (!input || !btn || !list) return;

    function syncFromInput() {
      var val = input.value;
      var ph = (labelSpan && labelSpan.getAttribute('data-placeholder')) || '';
      if (labelSpan) {
        labelSpan.textContent = val === '' ? ph : val;
      }
      wrap.querySelectorAll('[role="option"]').forEach(function (li) {
        var v = li.getAttribute('data-value');
        if (v == null) v = '';
        var selected = v === val;
        li.setAttribute('aria-selected', selected ? 'true' : 'false');
        li.classList.toggle('is-selected', selected);
      });
    }

    function close() {
      list.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', 'false');
      wrap.classList.remove('is-open');
    }

    function open() {
      list.removeAttribute('hidden');
      btn.setAttribute('aria-expanded', 'true');
      wrap.classList.add('is-open');
    }

    function toggle() {
      if (list.hasAttribute('hidden')) open();
      else close();
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      toggle();
    });

    wrap.querySelectorAll('[role="option"]').forEach(function (li) {
      li.addEventListener('click', function (e) {
        e.stopPropagation();
        if (li.hasAttribute('hidden')) return;
        var v = li.getAttribute('data-value');
        if (v == null) v = '';
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        close();
        btn.focus();
      });
    });

    document.addEventListener('click', function (e) {
      if (!wrap.classList.contains('is-open')) return;
      if (!wrap.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!wrap.classList.contains('is-open')) return;
      close();
      if (btn.focus) btn.focus();
    });

    input.addEventListener('change', syncFromInput);
    syncFromInput();
  }

  function normalizeQuizImageUrl(url) {
    if (!url) return '';
    return String(url).split('?')[0];
  }

  function quizImageUrlsMatch(a, b) {
    return normalizeQuizImageUrl(a) === normalizeQuizImageUrl(b);
  }

  function buildQuizImageSrcset(image) {
    if (!image || !image.src) return '';
    var parts = [];
    if (image.src_400) parts.push(image.src_400 + ' 400w');
    if (image.src_700) parts.push(image.src_700 + ' 700w');
    if (image.src_1000) parts.push(image.src_1000 + ' 1000w');
    if (image.src) parts.push(image.src + ' 1200w');
    return parts.join(', ');
  }

  function setQuizGalleryImage(target, image, heroSizes) {
    if (!target || !image || !image.src) return;
    var img = target.tagName === 'IMG' ? target : target.querySelector('img');
    if (!img) return;
    img.src = image.src;
    var srcset = buildQuizImageSrcset(image);
    if (srcset) {
      img.srcset = srcset;
    } else {
      img.removeAttribute('srcset');
    }
    if (image.alt) img.alt = image.alt;
    if (heroSizes) img.sizes = heroSizes;
    target.hidden = false;
    target.classList.remove('koz-quiz-result__gallery-cell--hidden');
  }

  function updateQuizGallery(card, variant) {
    var gallery = card.querySelector('.koz-quiz-result__gallery');
    if (!gallery || !variant) return;

    var heroTarget = gallery.querySelector('[data-quiz-gallery-hero]');
    var thumbTargets = Array.prototype.slice.call(gallery.querySelectorAll('[data-quiz-gallery-thumb]'));
    var thumbRow = gallery.querySelector('.koz-quiz-result__gallery-top');
    var allMedia = [];
    var mediaScript = card.querySelector('[data-quiz-product-media]');

    if (mediaScript) {
      try {
        allMedia = JSON.parse(mediaScript.textContent) || [];
      } catch (e) {
        allMedia = [];
      }
    }

    if (heroTarget && variant.featured_image && variant.featured_image.src) {
      setQuizGalleryImage(heroTarget, variant.featured_image, '(min-width: 990px) 45vw, 92vw');
    }

    var excludeId = variant.featured_media_id || null;
    var excludeUrl = variant.featured_image && variant.featured_image.src ? variant.featured_image.src : '';
    var thumbMedia = allMedia.filter(function (media) {
      if (!media || !media.src) return false;
      if (excludeId && media.id === excludeId) return false;
      if (excludeUrl && quizImageUrlsMatch(media.src, excludeUrl)) return false;
      return true;
    });

    if (thumbTargets.length) {
      thumbTargets.forEach(function (cell, index) {
        var media = thumbMedia[index];
        if (media) {
          setQuizGalleryImage(cell, media, '(min-width: 990px) 22vw, 42vw');
        } else {
          cell.hidden = true;
          cell.classList.add('koz-quiz-result__gallery-cell--hidden');
        }
      });
      if (thumbRow) {
        var visibleThumbs = thumbTargets.filter(function (cell) {
          return !cell.hidden;
        });
        thumbRow.hidden = visibleThumbs.length === 0;
        thumbRow.classList.toggle('koz-quiz-result__gallery-top--empty', visibleThumbs.length === 0);
      }
    }
  }

  function initQuizResultCard(card) {
    var json = card.querySelector('[data-quiz-variant-rows]');
    if (!json) return;
    var rows;
    try {
      rows = JSON.parse(json.textContent);
    } catch (e) {
      return;
    }
    if (!rows || !rows.length) return;

    var idInput = card.querySelector('input[name="id"].product-variant-id');
    var priceEl = card.querySelector('[data-quiz-price]');
    var compareWrap = card.querySelector('[data-quiz-price-compare-wrap]');
    var compareEl = card.querySelector('[data-quiz-price-compare]');
    var skuEl = card.querySelector('[data-quiz-sku]');
    var qtyInput = card.querySelector('[data-quiz-qty]');
    var atcBtn = card.querySelector('[data-quiz-atc]');
    var atcLabel = card.querySelector('[data-quiz-atc-label]');
    var soldOutMsg = card.querySelector('.sold-out-message');
    var viewProductLink = card.querySelector('[data-quiz-view-product]');
    var customAtc = card.getAttribute('data-atc-label') || '';

    function selectedOptionValues() {
      var fieldsets = Array.from(card.querySelectorAll('[data-quiz-option-index]'));
      fieldsets.sort(function (a, b) {
        return (
          parseInt(a.getAttribute('data-quiz-option-index'), 10) -
          parseInt(b.getAttribute('data-quiz-option-index'), 10)
        );
      });
      return fieldsets.map(function (fs) {
        var r = fs.querySelector('input[type="radio"][data-quiz-variant-radio]:checked');
        return r ? r.value : null;
      });
    }

    function applyVariant(variant) {
      if (!variant || !idInput) return;
      idInput.value = String(variant.id);
      idInput.disabled = !variant.available;
      if (priceEl) priceEl.textContent = variant.price;
      if (compareEl && compareWrap) {
        if (variant.compare_at) {
          compareEl.textContent = variant.compare_at;
          compareWrap.removeAttribute('hidden');
        } else {
          compareEl.textContent = '';
          compareWrap.setAttribute('hidden', '');
        }
      }
      if (skuEl) {
        if (variant.sku) {
          skuEl.textContent = variant.sku;
          skuEl.classList.remove('visually-hidden');
        } else {
          skuEl.textContent = '';
          skuEl.classList.add('visually-hidden');
        }
      }
      if (qtyInput && variant.qty) {
        qtyInput.min = variant.qty.min;
        qtyInput.setAttribute('data-min', String(variant.qty.min));
        qtyInput.step = String(variant.qty.increment);
        if (variant.qty.max != null) {
          qtyInput.max = variant.qty.max;
          qtyInput.setAttribute('data-max', String(variant.qty.max));
        } else {
          qtyInput.removeAttribute('max');
          qtyInput.removeAttribute('data-max');
        }
        qtyInput.value = String(variant.qty.min);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        if (atcLabel) {
          if (variant.available) {
            atcLabel.textContent = customAtc || (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
          } else {
            atcLabel.textContent = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
          }
        }
        if (soldOutMsg) {
          if (variant.available) soldOutMsg.classList.add('hidden');
          else soldOutMsg.classList.remove('hidden');
        }
      }
      updateQuizGallery(card, variant);
      if (viewProductLink) {
        var productUrl = viewProductLink.getAttribute('data-product-url') || viewProductLink.pathname;
        if (productUrl && variant && variant.id) {
          viewProductLink.href = productUrl.split('?')[0] + '?variant=' + variant.id;
        }
      }
    }

    function syncFromRadios() {
      var fieldsets = card.querySelectorAll('[data-quiz-option-index]');
      if (!fieldsets.length) {
        applyVariant(rows[0]);
        return;
      }
      var sel = selectedOptionValues();
      if (sel.some(function (x) { return x == null; })) return;
      var row = findQuizVariant(rows, sel);
      if (row) applyVariant(row);
      card.querySelectorAll('[data-quiz-variant-radio]').forEach(function (inp) {
        var lab = inp.closest('.koz-quiz-result__pill');
        if (lab) lab.classList.toggle('is-selected', inp.checked);
      });
    }

    if (!card.querySelector('[data-quiz-variant-radio]')) {
      applyVariant(rows[0]);
      return;
    }

    card.querySelectorAll('[data-quiz-variant-radio]').forEach(function (inp) {
      inp.addEventListener('change', syncFromRadios);
    });

    syncFromRadios();
  }

  function init(root) {
    var rules = parseRules(root);
    var pantMin = parseFloat(root.getAttribute('data-pant-min'));
    var pantMax = parseFloat(root.getAttribute('data-pant-max'));
    var pantStep = parseInt(root.getAttribute('data-pant-step'), 10);
    if (isNaN(pantMin)) pantMin = 26;
    if (isNaN(pantMax)) pantMax = 50;
    if (isNaN(pantStep)) pantStep = 2;
    var resultAction = root.getAttribute('data-result-action') || 'show_card';

    var steps = root.querySelectorAll('.koz-seat-quiz__step');
    var btnIntro = root.querySelector('[data-quiz-next="intro"]');
    var btnCategoryNext = root.querySelector('[data-quiz-next="category"]');
    var btnCategoryBack = root.querySelector('[data-quiz-back="category"]');
    var btnStyleNext = root.querySelector('[data-quiz-next="style"]');
    var btnStyleBack = root.querySelector('[data-quiz-back="style"]');
    var btnCertNext = root.querySelector('[data-quiz-next="certification"]');
    var btnCertBack = root.querySelector('[data-quiz-back="certification"]');
    var btnPantNext = root.querySelector('[data-quiz-next="pant"]');
    var btnPantBack = root.querySelector('[data-quiz-back="pant"]');
    var btnFitSubmit = root.querySelector('[data-quiz-submit]');
    var btnFitBack = root.querySelector('[data-quiz-back="fit"]');
    var btnRestart = root.querySelector('[data-quiz-restart]');
    var pantInput = root.querySelector('[data-quiz-pant-input]');
    initPantDropdown(root);
    var fallbackEl = root.querySelector('[data-quiz-fallback]');
    var liveRegion = root.querySelector('[data-quiz-live]');

    var state = {
      category: null,
      seat: null,
      certification: null,
      pant: null,
      fit: null,
      stepSequence: [],
    };

    var applicablePantSizes = [];

    /** Rules that apply to this category (category-specific + “Any” category). */
    function rulesForCategory(category) {
      return rules.filter(function (r) {
        return !r.category || r.category === 'any' || r.category === category;
      });
    }

    function stepNeeded(category, field) {
      return rulesForCategory(category).some(function (r) {
        var val = r[field];
        return val && val !== 'any';
      });
    }

    /** Ordered steps after category: certification/style (as needed), pant, fit (optional). */
    function buildStepSequence(category) {
      var seq = [];
      var needCert = stepNeeded(category, 'certification');
      var needStyle = stepNeeded(category, 'seat');
      var needFit = stepNeeded(category, 'fit');

      if (needCert && needStyle) {
        if (category === 'motorsport_track') {
          seq.push('certification', 'style');
        } else {
          seq.push('style', 'certification');
        }
      } else {
        if (needCert) seq.push('certification');
        if (needStyle) seq.push('style');
      }
      seq.push('pant');
      if (needFit) seq.push('fit');
      return seq;
    }

    function stepBefore(stepName) {
      var seq = state.stepSequence;
      var i = seq.indexOf(stepName);
      if (i <= 0) return 'category';
      return seq[i - 1];
    }

    function stepAfter(stepName) {
      var seq = state.stepSequence;
      var i = seq.indexOf(stepName);
      if (i < 0 || i >= seq.length - 1) return null;
      return seq[i + 1];
    }

    function firstStepAfterCategory() {
      return state.stepSequence.length ? state.stepSequence[0] : 'pant';
    }

    function showStep(name) {
      steps.forEach(function (s) {
        var on = s.getAttribute('data-step') === name;
        if (on) {
          s.removeAttribute('hidden');
        } else {
          s.setAttribute('hidden', '');
        }
      });
      if (name === 'pant') {
        refreshPantOptions();
      }
    }

    function refreshPantOptions() {
      if (!state.category) return;

      var seat = stepIsInSequence('style') ? state.seat || 'any' : 'any';
      var certification = stepIsInSequence('certification') ? state.certification || 'any' : 'any';

      applicablePantSizes = getApplicablePantSizes(
        rules,
        state.category,
        seat,
        certification,
        pantMin,
        pantMax,
        pantStep
      );

      root.querySelectorAll('.koz-seat-quiz__pant-dd-option').forEach(function (li) {
        if (li.classList.contains('koz-seat-quiz__pant-dd-option--placeholder')) return;
        var v = parseFloat(li.getAttribute('data-value'));
        var show = applicablePantSizes.indexOf(v) !== -1;
        if (show) {
          li.removeAttribute('hidden');
        } else {
          li.setAttribute('hidden', '');
        }
      });

      if (pantInput && pantInput.value !== '') {
        var current = parseFloat(pantInput.value);
        if (applicablePantSizes.indexOf(current) === -1) {
          pantInput.value = '';
          pantInput.dispatchEvent(new Event('change', { bubbles: true }));
          state.pant = null;
        }
      }
    }

    function validatePant() {
      if (!pantInput) return false;
      var raw = pantInput.value;
      if (raw === '' || String(raw).trim() === '') return false;
      var v = parseFloat(raw);
      if (isNaN(v)) return false;
      if (applicablePantSizes.length) {
        return applicablePantSizes.indexOf(v) !== -1;
      }
      return v >= pantMin && v <= pantMax && v % pantStep === 0;
    }

    function announce(msg) {
      if (liveRegion) {
        liveRegion.textContent = '';
        liveRegion.textContent = msg;
      }
    }

    function hideFallback() {
      if (fallbackEl) {
        fallbackEl.setAttribute('hidden', '');
        fallbackEl.setAttribute('aria-hidden', 'true');
      }
    }

    function showFallback() {
      hideAllCards(root);
      if (fallbackEl) {
        fallbackEl.removeAttribute('hidden');
        fallbackEl.setAttribute('aria-hidden', 'false');
        var fh = fallbackEl.querySelector('[data-quiz-fallback-heading]');
        if (fh && fh.focus) fh.focus();
      }
    }

    function openResultsView() {
      root.classList.add('koz-seat-quiz--show-results');
      steps.forEach(function (s) {
        if (s.getAttribute('data-step') === 'results') {
          s.removeAttribute('hidden');
        } else {
          s.setAttribute('hidden', '');
        }
      });
    }

    function matchValues() {
      return {
        category: state.category,
        seat: state.seat || 'any',
        certification: state.certification || 'any',
        fit: state.fit || 'any',
      };
    }

    function stepIsInSequence(stepName) {
      return state.stepSequence.indexOf(stepName) !== -1;
    }

    function submitQuiz() {
      if (!state.category || state.pant == null) return;
      if (stepIsInSequence('style') && !state.seat) return;
      if (stepIsInSequence('certification') && !state.certification) return;
      if (stepIsInSequence('fit') && !state.fit) return;

      var values = matchValues();
      var match = findMatch(
        rules,
        values.category,
        values.seat,
        values.certification,
        state.pant,
        values.fit
      );

      if (resultAction === 'redirect' && match && match.productUrl) {
        window.location.href = match.productUrl;
        return;
      }

      openResultsView();
      hideFallback();
      if (match && match.productId) {
        showCard(root, String(match.productId));
        announce(
          (root.getAttribute('data-msg-result-prefix') || 'Your recommendation: ') +
            (match.productTitle || '')
        );
      } else {
        showFallback();
        announce(root.getAttribute('data-msg-no-match') || 'No matching product for those answers.');
      }
    }

    function resetQuiz() {
      root.classList.remove('koz-seat-quiz--show-results');
      state = {
        category: null,
        seat: null,
        certification: null,
        pant: null,
        fit: null,
        stepSequence: [],
      };
      if (pantInput) {
        if (pantInput.tagName === 'SELECT') {
          pantInput.selectedIndex = 0;
        } else {
          pantInput.value = '';
        }
        pantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      root.querySelectorAll('[data-quiz-category]').forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
        b.classList.remove('is-selected');
      });
      root.querySelectorAll('[data-quiz-seat]').forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
        b.classList.remove('is-selected');
      });
      root.querySelectorAll('[data-quiz-certification]').forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
        b.classList.remove('is-selected');
      });
      root.querySelectorAll('[data-quiz-fit]').forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
        b.classList.remove('is-selected');
      });
      hideAllCards(root);
      hideFallback();
      showStep('intro');
      announce('');
      var introHeading = root.querySelector('.koz-seat-quiz__step[data-step="intro"] h2');
      if (introHeading && introHeading.focus) introHeading.focus();
    }

    if (btnIntro) {
      btnIntro.addEventListener('click', function () {
        showStep('category');
      });
    }

    root.querySelectorAll('[data-quiz-category]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var category = btn.getAttribute('data-quiz-category');
        state.category = category;
        state.stepSequence = buildStepSequence(category);
        state.seat = null;
        state.certification = null;
        state.fit = null;
        root.querySelectorAll('[data-quiz-category]').forEach(function (b) {
          var sel = b === btn;
          b.setAttribute('aria-pressed', sel ? 'true' : 'false');
          b.classList.toggle('is-selected', sel);
        });
        root.querySelectorAll('[data-quiz-seat]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
          b.classList.remove('is-selected');
        });
        root.querySelectorAll('[data-quiz-certification]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
          b.classList.remove('is-selected');
        });
        root.querySelectorAll('[data-quiz-fit]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
          b.classList.remove('is-selected');
        });
      });
    });

    if (btnCategoryNext) {
      btnCategoryNext.addEventListener('click', function () {
        if (!state.category) return;
        if (!state.stepSequence.length) {
          state.stepSequence = buildStepSequence(state.category);
        }
        showStep(firstStepAfterCategory());
      });
    }

    if (btnCategoryBack) {
      btnCategoryBack.addEventListener('click', function () {
        showStep('intro');
      });
    }

    root.querySelectorAll('[data-quiz-seat]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var seat = btn.getAttribute('data-quiz-seat');
        state.seat = seat;
        root.querySelectorAll('[data-quiz-seat]').forEach(function (b) {
          var sel = b === btn;
          b.setAttribute('aria-pressed', sel ? 'true' : 'false');
          b.classList.toggle('is-selected', sel);
        });
      });
    });

    if (btnStyleNext) {
      btnStyleNext.addEventListener('click', function () {
        if (!state.seat) return;
        var next = stepAfter('style');
        showStep(next || 'pant');
      });
    }

    if (btnStyleBack) {
      btnStyleBack.addEventListener('click', function () {
        showStep(stepBefore('style'));
      });
    }

    root.querySelectorAll('[data-quiz-certification]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var certification = btn.getAttribute('data-quiz-certification');
        state.certification = certification;
        root.querySelectorAll('[data-quiz-certification]').forEach(function (b) {
          var sel = b === btn;
          b.setAttribute('aria-pressed', sel ? 'true' : 'false');
          b.classList.toggle('is-selected', sel);
        });
      });
    });

    if (btnCertNext) {
      btnCertNext.addEventListener('click', function () {
        if (!state.certification) return;
        var next = stepAfter('certification');
        showStep(next || 'pant');
      });
    }

    if (btnCertBack) {
      btnCertBack.addEventListener('click', function () {
        showStep(stepBefore('certification'));
      });
    }

    if (btnPantNext) {
      btnPantNext.addEventListener('click', function () {
        if (!validatePant()) {
          var focusEl = pantInput;
          if (pantInput && pantInput.getAttribute('type') === 'hidden') {
            var tr = root.querySelector('[data-quiz-pant-focus]');
            if (tr) focusEl = tr;
          }
          if (focusEl && focusEl.focus) focusEl.focus();
          announce(root.getAttribute('data-msg-pant-invalid') || 'Enter a valid pant size.');
          return;
        }
        state.pant = parseFloat(pantInput.value);
        announce('');
        var next = stepAfter('pant');
        if (next === 'fit') {
          showStep('fit');
        } else {
          state.fit = 'any';
          submitQuiz();
        }
      });
    }

    if (btnPantBack) {
      btnPantBack.addEventListener('click', function () {
        showStep(stepBefore('pant'));
      });
    }

    root.querySelectorAll('[data-quiz-fit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var fit = btn.getAttribute('data-quiz-fit');
        state.fit = fit;
        root.querySelectorAll('[data-quiz-fit]').forEach(function (b) {
          var sel = b === btn;
          b.setAttribute('aria-pressed', sel ? 'true' : 'false');
          b.classList.toggle('is-selected', sel);
        });
      });
    });

    if (btnFitBack) {
      btnFitBack.addEventListener('click', function () {
        showStep('pant');
      });
    }

    if (btnFitSubmit) {
      btnFitSubmit.addEventListener('click', function () {
        if (!state.fit) return;
        submitQuiz();
      });
    }

    if (btnRestart) {
      btnRestart.addEventListener('click', function () {
        resetQuiz();
      });
    }

    root.querySelectorAll('[data-koz-quiz-result]').forEach(initQuizResultCard);
  }

  document.querySelectorAll('[data-koz-seat-quiz]').forEach(init);
})();
